import { ofType } from "redux-observable";
import { map } from "rxjs/operators";
import { actionGameTrackingUpdateShop } from "../../actionGameTracking";
import { TypeActionGameTrackingShopOpenSource, } from "../actionGameTrackingShop";
import { IdGameTrackingShopState } from "../IdGameTrackingShopState";
export var epicGameTrackingShopPackageShow = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionGameTrackingShopOpenSource.PackageShow), map(function (action) {
        return actionGameTrackingUpdateShop(IdGameTrackingShopState.LOADED_GAME_PACKAGE, action.offerNameId);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/shop/epics/epicGameTrackingShopPackageShow.ts
// module id = 1881
// module chunks = 3